module.exports = __webpack_public_path__ + "static/media/customerServiceimg7.79d4b3fb.png";